module.exports = __webpack_public_path__ + "static/media/bitpay-dark.f86a15da.svg";